<template>
  <div class="xiaobu-container" v-closeSelect="'window'">
    <el-form ref="queryForm" :model="queryParams" :inline="true" class="search-form clearfix">
      <el-form-item class="search-field fl five-per-row" label="统计维度" prop="dimension">
        <el-select-dict dictType="DIMENSION" v-model.trim="queryParams.dimension" placeholder="请选择统计维度"
          @dictChange="handleQuery" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="仓库" prop="wareHouseId">
        <el-cascader aria-hidden="false" :options="wareHouseData" @change="handleQuery" clearable :props="defaultProps"
          v-model="wareHouseId" placeholder="请选择仓库" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="商品名称" prop="goodsName">
        <el-input v-model.trim="queryParams.goodsName" clearable @keyup.enter.native="handleQuery"
          placeholder="请输入商品名称" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="商品编号" prop="goodsSn">
        <el-input v-model.trim="queryParams.goodsSn" clearable @keyup.enter.native="handleQuery"
          placeholder="请输入商品编号" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="单品编号" prop="spuSn">
        <el-input v-model.trim="queryParams.spuSn" clearable @keyup.enter.native="handleQuery" placeholder="请输入单品编号" />
      </el-form-item>

      <el-form-item class="search-field fl five-per-row" label="生产日期">
        <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd" type="daterange" @change="handleQuery"
          range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>

      <el-form-item class="fr">
        <el-button plain @click="resetQuery">重 置</el-button>
        <el-button type="primary" @click="handleQuery">查 询</el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <div class="table-control-box">
      </div>
      <div class="table-box">
        <auto-height-table instanceHeight="238" :key="queryParams.dimension" ref="statisticsTable" :class="{ 'empty': list.length === 0 }" empty-text=" "
          v-loading="loading" :data="list">
          <el-table-column v-if="queryParams.dimension === 'wareHouseId'" label="仓库" prop="wareHouseName" align="center"
            min-width="128px">
            <template slot-scope="scope">
              {{ getWareHouseName(scope.row.wareHouseId) }}
            </template>
          </el-table-column>
          <el-table-column label="商品信息" prop="goodsName" align="left" min-width="256px">
            <template slot-scope="scope">
              <div class="goods-info flex-c-s">
                <div class="goods-info-left">
                  <img @click.stop="mixinHandlePreview(scope.row.goodsImgs && scope.row.goodsImgs.split(','))"
                    :src="mixinGetImg(scope.row.goodsImgs && scope.row.goodsImgs.split(',')[0])" width="40px" height="40px"
                    alt="商品图片">
                </div>
                <div class="goods-info-right flex-c-c flex-col">
                  <div class="top">
                    <span class="label">名称：</span>
                    <span class="value">{{ scope.row.goodsName }}</span>
                  </div>
                  <div class="bottom">
                    <span class="label">编号：</span>
                    <span class="value">{{ scope.row.goodsSn }}</span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="规格信息" prop="skuListStr" align="left" min-width="256px">
            <template slot-scope="scope">
              <div class="goods-info-right flex-c-c flex-col">
                <div class="top">
                  <span class="label">规格：</span>
                  <span class="value">{{ scope.row.skuListStr }}</span>
                </div>
                <div class="bottom">
                  <span class="label">编号：</span>
                  <span class="value">{{ scope.row.spuSn }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="queryParams.dimension === 'goodsId'" label="仓库" prop="wareHouseName" align="center"
            min-width="128px">
            <template slot-scope="scope">
              {{ getWareHouseName(scope.row.wareHouseId) }}
            </template>
          </el-table-column>
          <el-table-column label="成本单价(元)" prop="costPrice" align="center" min-width="128px" />
          <el-table-column label="生产日期" prop="manufactureDate" align="center" min-width="128px" />
          <el-table-column label="保质期(天)" prop="qualityGuaranteePeriod" align="center" min-width="128px" />
          <el-table-column label="库存数量" prop="spuNumber" align="center" min-width="128px" />
        </auto-height-table>

        <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize" @pagination="getList" />
      </div>
    </div>
  </div>
</template>

<script>
import { wareHouseApi, statisticsApi } from "@/api"
import { getPathByTreeValue } from "vue2-element-admin-plugin"
import {markNonLeafNodes} from "@/utils/tree"
export default {
  name: "inventoryStatisticsManage",
  data() {
    return {
      dateRange: [], // 
      wareHouseId: [], // 仓库列表
      wareHouseData: [], // 仓库树 数据
      defaultProps: {
        checkStrictly: true,
        value: "wareHouseId",
        children: "children",
        label: "wareHouseName"
      },
      //搜索条件参数
      queryParams: {
        dimension: "goodsId", // 入库单号
        goodsName: "", // 商品名称
        goodsSn: "", // 商品编号
        spuSn: "", // 单品编号
        wareHouseId: "", // 仓库id
        beginTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10
      },
      list: [],
      loading: false,
      total: 0
    }
  },
  async created() {
    const { query } = this.$route
    this.queryParams = Object.assign(this.queryParams, query)
    await this.getWareHouseTree()
    //获取列表
    this.getList()
  },
  methods: {
    // 获取仓库名字
    getWareHouseName(val) {
      const list = getPathByTreeValue(this.wareHouseData, val, { targetField: "wareHouseId", childrenField: "children" }, true)
      return list[list.length - 1].labelArr.join("/")
    },
    // 获取仓库列表
    getWareHouseTree() {
      return wareHouseApi.getWareHouseTree().then((data) => {
        this.wareHouseData = markNonLeafNodes(data, this.mixinWareHouseIdList, {idField: "wareHouseId"})
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.wareHouseId = []
      this.mixinResetForm("queryForm")
      this.queryParams.goodsSn = ""
      this.queryParams.spuSn = ""

      this.handleQuery()
    },
    /** 查询列表 */
    getList() {
      this.loading = true
      // 获取仓库id
      if (this.wareHouseId && this.wareHouseId.length > 0) {
        this.queryParams.wareHouseId = this.wareHouseId[this.wareHouseId.length - 1]
      } else {
        this.queryParams.wareHouseId = ""
      }

      statisticsApi
        .getList(this.mixinAddDateRange(this.queryParams, this.dateRange, "date"))
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          this.loading = false
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    }
  }
}
</script>